/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'copy-document': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="#213F6B" fill-rule="evenodd"><path pid="0" d="M9 4a4 4 0 014 4v8a4 4 0 01-4 4H4a4 4 0 01-4-4V8a4 4 0 014-4h5zm0 2H4a2 2 0 00-2 2v8a2 2 0 002 2h5a2 2 0 002-2V8a2 2 0 00-2-2z"/><path pid="1" d="M16 0a4 4 0 014 4v8a4 4 0 01-4 4h-3v-2h3a2 2 0 002-2V4a2 2 0 00-2-2h-5a2 2 0 00-2 2H7a4 4 0 014-4h5z"/></g>'
  }
})
